import { axiosAiq } from 'config';

export const refreshToken = () => axiosAiq.post('/auth/refresh');
